import React, { useState } from 'react';
import SearchIcon from "../../../assets/images/icons/search.svg";
import { Link } from 'react-router-dom';
import { useSelector, useDispatch } from "react-redux";
import * as actions from '../../../redux/actions/growthEngine';
import AsyncSelect from 'react-select/async';
import { getCustomSelectStyles } from '../../../helper/utility'
import debounce from "lodash.debounce";
import { toast } from 'react-toastify';

export const YoutubeTarget = () => {
    const dispatch = useDispatch();
    const { formData } = useSelector(state => state.growthEngine);
    // const [selectedLocation, setSelectedLocation] = useState('');

    const englishSpeakingMusicCountry = [
        { id: 2840, name: "United States", countryCode: "US", type: "Country" },
        { id: 2392, name: "Japan", countryCode: "JP", type: "Country" },
        { id: 2826, name: "United Kingdom", countryCode: "GB", type: "Country" },
        { id: 2276, name: "Germany", countryCode: "DE", type: "Country" },
        { id: 2056, name: "France", countryCode: "FR", type: "Country" },
        { id: 2124, name: "Canada", countryCode: "CA", type: "Country" },
        { id: 2036, name: "Australia", countryCode: "AU", type: "Country" },
        { id: 2236, name: "Netherlands", countryCode: "NL", type: "Country" }
    ];

    const GLOBAL_COUNTRY = {
        id: 2384,
        name: "All Countries and Territories",
        countryCode: "GLOBAL",
        type: "CountryGroup"
    };

    // derive selected location
    const selectedLocation = (() => {
        const selectedIds = formData.youtubeTargetCountry?.map(c => c.id) || [];

        const isGlobal =
            selectedIds.length === 1 && selectedIds[0] === GLOBAL_COUNTRY.id;

        const englishIds = englishSpeakingMusicCountry.map(c => c.id);
        const isEnglish =
            selectedIds.length === englishIds.length &&
            englishIds.every(id => selectedIds.includes(id));

        if (isGlobal) return 'global-markets';
        if (isEnglish) return 'english-speaking-markets';
        return 'custom';
    })();

    const handleLocationChange = (value) => {
        switch (value) {
            case 'global-markets':
                dispatch(actions.updateFormData({ youtubeTargetCountry: [GLOBAL_COUNTRY] }));
                break;
            case 'english-speaking-markets':
                dispatch(actions.updateFormData({ youtubeTargetCountry: englishSpeakingMusicCountry }));
                break;
            case 'custom':
                dispatch(actions.updateFormData({ youtubeTargetCountry: [] })); // let user pick
                break;
        }
    };

    const SelectedLocationTag = ({ location, type }) => {
        return (
            <div className="bg-gradient-to-b from-[#FA6138] to-[#FF3D00] text-white text-[13px] font-roboto flex items-center gap-2 capitalize rounded-lg leading-tight pl-4 p-[8px]">
                {/* Show name and type */}
                {location.name} ({location.type})

                {/* Remove location */}
                <i
                    className="bi bi-x text-base leading-none cursor-pointer"
                    onClick={() => removeLocation(location.id)}
                ></i>
            </div>
        );
    };
    const removeLocation = (idToRemove) => {
        const updated = formData.youtubeTargetCountry.filter(loc => loc.id !== idToRemove);
        dispatch(actions.updateFormData({ youtubeTargetCountry: updated }));
    };

    const formatLocationLabel = (location) => {
        return location.name;  // Default fallback
    };

    const fetchLocations = debounce((inputValue, callback) => {
        if (inputValue.length > 2) {
            dispatch(actions.getYoutubeTargetLocation(inputValue, toast))
                .then((response) => {
                    if (response.length > 0) {
                        callback(response.map(item => ({
                            label: (
                                <div>
                                    <div>{formatLocationLabel(item)}</div>
                                    <div className="text-xs text-white-400">{item.type}</div>
                                </div>
                            ),
                            value: item.id, // Unique ID
                            name: item.name, // Only  name
                            type: item.type, // Type (city, region, country)
                            countryCode: item.countryCode,     // country code
                            labelString: formatLocationLabel(item),
                        })));
                    } else {
                        callback([]);
                    }
                })
                .catch(() => callback([]));
        } else {
            callback([]);
        }
    }, 1000);

    const handleCustomeLocationChange = (option) => {
        if (!option) return;
        const existingIds = formData.youtubeTargetCountry?.map(item => item.id) || [];
        // If already exists, skip
        if (existingIds.includes(option.value)) return;

        const newLocation = {
            id: option.value,
            name: option.name,
            countryCode: option.countryCode,
            type: option.type,
        };

        dispatch(actions.updateFormData({
            youtubeTargetCountry: [...formData.youtubeTargetCountry, newLocation]
        }));
    };

    // suggested channel functionality
    const fetchSuggetedChannel = debounce((inputValue, callback) => {
        if (inputValue.length > 2) {
            dispatch(actions.getSuggestedChannel(inputValue, toast))
                .then((response) => {
                    if (response.length > 0) {
                        callback(response.map(item => ({
                            label: (
                                <div>
                                    <div>{item.title}</div>
                                    {/* <div className="text-xs text-white-400">{item.type}</div> */}
                                </div>
                            ),
                            value: item.channelId,
                            name: item.title,
                            url: item.url,
                            labelString: item.title,
                        })));
                    } else {
                        callback([]);
                    }
                })
                .catch(() => callback([]));
        } else {
            callback([]);
        }
    }, 500);

    const handleChannelSuggestionChange = (option) => {
        if (!option) return;
        const existingIds = formData.youtubeTargetChannels?.map(item => item.channelId) || [];
        // If already exists, skip
        if (existingIds.includes(option.value)) return;

        const newChannels = {
            channelId: option.value,
            title: option.name,
            url: option.url,
        };

        dispatch(actions.updateFormData({
            youtubeTargetChannels: [...formData.youtubeTargetChannels, newChannels]
        }));
    };
    const removeChannel = (idToRemove) => {
        const updated = formData.youtubeTargetChannels.filter(loc => loc.channelId !== idToRemove);
        dispatch(actions.updateFormData({ youtubeTargetChannels: updated }));
    };

    return (
        <div className="ChooseYoutubeVideo-page bg-theme_clr1 font-inter py-5">
            <div className="container max-w-[875px]">
                <section className="mt-10">
                    <div className="heading text-white font-medium text-center mb-[28.5px]">
                        <h5 className="text-[22.5px] mb-2">Choose your Targeting</h5>
                        <div className="description text-white text-opacity-80 text-[15px]">Choose your campaign type who you want your ad to be shown to</div>
                    </div>

                    <div className="info-box bg-white divide-y space-y-1 divide-[#E5E7EB] !rounded-xl">
                        {/* 1st Info Section */}
                        <div className="content-wrapper bg-white rounded-t-xl p-4 lg:px-8">
                            <div className="title-wrapper font-inter mb-4">
                                <div className="text-black text-lg font-bold">Campaign Type</div>
                                <div className="text-[#6B7280] text-base">Optimize your campaign for the cheapest video views or to drive subscribers.</div>
                            </div>

                            <div className="radio-wrapper">
                                <ul className="bg-white font-roboto border border-[#E5E7EB] rounded-lg">
                                    <li className={`border-b border-[#E5E7EB] p-4 lg:px-8 lg:py-5 
                                        ${formData.advertisingChannelSubType === 'VIDEO_TRUEVIEW_IN_STREAM' ? 'bg-[#ECFDF5]' : ''}`}
                                    >
                                        <div className="flex gap-3">
                                            <input id="cheapest-views" type="radio" name="CampaignType" value="VIDEO_TRUEVIEW_IN_STREAM"
                                                checked={formData.advertisingChannelSubType === 'VIDEO_TRUEVIEW_IN_STREAM'}
                                                onChange={(e) => dispatch(actions.updateFormData({ advertisingChannelSubType: e.target.value }))} className="w-4 min-w-4 h-4 mt-1" />
                                            <label htmlFor="cheapest-views" className="text-black flex-1">
                                                <div className="label-title font-semibold">📈 Cheapest Views</div>
                                                <div className="label-subtitle">Run your video ads to drive as many views as possible on your video.</div>
                                                <div className="label-desc text-[#6B7280] text-sm mt-[2px]">Runs using YouTube Pre-roll Ads (Skippable)</div>
                                            </label>
                                        </div>
                                    </li>
                                    <li className={`p-4 lg:px-8 lg:py-5 ${formData.advertisingChannelSubType === 'VIDEO_DISCOVERY_AD' ? 'bg-[#ECFDF5]' : ''}`} >
                                        <div className="flex gap-3">
                                            <input id="more-engagement" type="radio" name="CampaignType" value="VIDEO_DISCOVERY_AD"
                                                checked={formData.advertisingChannelSubType === 'VIDEO_DISCOVERY_AD'}
                                                onChange={(e) => dispatch(actions.updateFormData({ advertisingChannelSubType: e.target.value }))}
                                                className="w-4 min-w-4 h-4 mt-1" />
                                            <label htmlFor="more-engagement" className="text-black flex-1">
                                                <div className="label-title font-semibold">🗣 More Engagement</div>
                                                <div className="label-subtitle">Run your video ads focused on driving more engagement to your video, including likes, comments, and subscribers.</div>
                                                <div className="label-desc text-[#6B7280] text-sm mt-[2px]">Runs using YouTube In-feed Discovery Ads</div>
                                            </label>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* 2nd Info Section */}
                        <div className="content-wrapper bg-white p-4 lg:px-8">
                            <div className="title-wrapper font-inter mb-4">
                                <div className="text-black text-lg font-bold">Locations</div>
                                <div className="text-[#6B7280] text-base">We automatically target your marketing in geographies we think will help you build your fanbase most effectively.</div>
                            </div>

                            <div className="radio-wrapper">
                                <ul className="bg-white font-roboto border border-[#E5E7EB] rounded-lg">
                                    <li className={`border-b border-[#E5E7EB] p-4 lg:px-8 lg:py-5 ${selectedLocation === 'english-speaking-markets' ? 'bg-[#ECFDF5]' : ''}`} >
                                        <div className="flex gap-3">
                                            <input id="english-speaking-markets" type="radio" name="locationRadio" value="english-speaking-markets" checked={selectedLocation === 'english-speaking-markets'} onChange={(e) => handleLocationChange(e.target.value)} className="w-4 min-w-4 h-4 mt-1" />
                                            <label htmlFor="english-speaking-markets" className="text-black flex-1">
                                                <div className="label-title font-semibold">🌎 English-speaking Markets</div>
                                                <div className="label-subtitle">Run your video ads only in countries where English is the primary language.</div>
                                                <div className="label-desc text-[#6B7280] text-sm mt-[2px]">This includes markets like the US, Canada, UK, and Australia. Average cost-per-view is 4 - 6 cents USD.</div>
                                            </label>
                                        </div>
                                    </li>
                                    <li className={`border-b border-[#E5E7EB] p-4 lg:px-8 lg:py-5 ${selectedLocation === 'global-markets' ? 'bg-[#ECFDF5]' : ''}`} >
                                        <div className="flex gap-3">
                                            <input id="global-markets" type="radio" name="locationRadio" value="global-markets" checked={selectedLocation === 'global-markets'} onChange={(e) => handleLocationChange(e.target.value)} className="w-4 min-w-4 h-4 mt-1" />
                                            <label htmlFor="global-markets" className="text-black flex-1">
                                                <div className="label-title font-semibold">🌐 Global Markets</div>
                                                <div className="label-subtitle">Run your video ads globally, everywhere YouTube is available.</div>
                                                <div className="label-desc text-[#6B7280] text-sm mt-[2px]">This includes markets like India, Mexico, Brazil, etc. Average cost-per-view is 1 cent USD or less.</div>
                                            </label>
                                        </div>
                                    </li>
                                    <li className={`p-4 lg:px-8 lg:py-5 ${selectedLocation === 'custom' ? 'bg-[#ECFDF5]' : ''}`} >
                                        <div className="flex gap-3 mb-3">
                                            <input id="custom" type="radio" name="locationRadio" value="custom" checked={selectedLocation === 'custom'} onChange={(e) => handleLocationChange(e.target.value)} className="w-4 min-w-4 h-4 mt-1" />
                                            <label htmlFor="custom" className="text-black flex-1">
                                                <div className="label-title font-semibold">📍 Custom</div>
                                                <div className="label-subtitle">Custom Run your video ads in specific countries.</div>
                                            </label>
                                        </div>
                                        {
                                            selectedLocation === 'custom' ?
                                                <div className="search-wrapper">
                                                    <div className="search-box bg-theme_clr1 rounded-full px-4 py-1 flex items-center relative">
                                                        <i className="bi bi-search text-white"></i>
                                                        <AsyncSelect
                                                            className="custom-select w-full text-white"
                                                            styles={getCustomSelectStyles()}
                                                            loadOptions={fetchLocations} // Fetch options asynchronously
                                                            defaultOptions // Show initial options
                                                            placeholder="Search location"
                                                            cacheOptions
                                                            noOptionsMessage={() => "No results found"} // Show message if no options
                                                            onFocus={() => dispatch(actions.updateFormData({ selectedLocationOption: "custom" }))}
                                                            onChange={handleCustomeLocationChange} // Handle selection
                                                            controlShouldRenderValue={false}
                                                            components={{
                                                                DropdownIndicator: () => null,
                                                                IndicatorSeparator: () => null,
                                                                SingleValue: ({ data }) => (
                                                                    <div>
                                                                        <div>{data.labelString}</div>
                                                                        <div className="text-xs text-white-400">{data.type}</div>
                                                                    </div>
                                                                ),
                                                            }}
                                                        />
                                                    </div>
                                                    {formData.youtubeTargetCountry && selectedLocation === 'custom' && (
                                                        <div className="search-suggestion flex flex-wrap gap-2 mt-4">
                                                            {/* Render cities */}
                                                            {formData.youtubeTargetCountry.map((location) => (
                                                                <SelectedLocationTag key={location.id} location={location} />
                                                            ))}
                                                        </div>
                                                    )}
                                                </div>
                                                : ''
                                        }

                                    </li>
                                </ul>
                            </div>
                        </div>

                        {/* 3rd Info Section */}
                        <div className="content-wrapper bg-white p-4 lg:px-8 mb-3">
                            <div className="title-wrapper font-inter">
                                <div className="text-black text-lg font-bold">Targeting</div>
                                {
                                    formData.advertisingChannelSubType === 'VIDEO_TRUEVIEW_IN_STREAM' ?
                                        <div className="text-[#6B7280] text-base">Target your video campaign by selecting relevant audiences - your ads will run on these channels.</div>
                                        :
                                        <div className='wrapper bg-slate-100 rounded-lg p-4 mt-3'>
                                            YouTube will automatically use its AI and your channel’s analytics to find the audiences most likely to engage with your music.
                                            The system analyzes your video’s content, past viewer behavior, and genre trends to maximize reach and engagement.
                                        </div>
                                }
                            </div>
                        </div>
                        {
                            formData.advertisingChannelSubType === 'VIDEO_TRUEVIEW_IN_STREAM' ?
                                <>
                                    {/* 4th Info Section */}
                                    <div className="content-wrapper bg-white px-4 lg:px-8 pb-1 pt-2">
                                        <div className="search-wrapper">
                                            <div className="search-box bg-theme_clr1 rounded-full px-4 py-1 flex items-center relative">
                                                <i className="bi bi-search text-white"></i>
                                                <AsyncSelect
                                                    className="custom-select w-full text-white"
                                                    styles={getCustomSelectStyles()}
                                                    loadOptions={fetchSuggetedChannel} // Fetch options asynchronously
                                                    defaultOptions // Show initial options
                                                    placeholder="Search for YouTube channels to target"
                                                    cacheOptions
                                                    noOptionsMessage={() => "No results found"} // Show message if no options
                                                    // onFocus={() => dispatch(actions.updateFormData({ selectedLocationOption: "custom" }))}
                                                    onChange={handleChannelSuggestionChange} // Handle selection
                                                    controlShouldRenderValue={false}
                                                    components={{
                                                        DropdownIndicator: () => null,
                                                        IndicatorSeparator: () => null,
                                                        SingleValue: ({ data }) => (
                                                            <div>
                                                                <div>{data.labelString}</div>
                                                                <div className="text-xs text-white-400">{data.type}</div>
                                                            </div>
                                                        ),
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    {/* 5th Info Section */}
                                    <div className="content-wrapper bg-white rounded-b-xl p-4 lg:px-8 mb-3">
                                        <div className="flex items-center gap-3 mb-4">
                                            <div className="icon">🛰</div>
                                            <div className="text-black text-base">Best Practice: We recommend adding at least 10 channels of medium + big creators in your genre.</div>
                                        </div>
                                        <div className="btn-wrapper text-sm flex flex-wrap gap-x-4 gap-y-3">
                                            {
                                                formData?.youtubeTargetChannels?.map((chl) => (
                                                    <div key={chl.channelId} className="bg-theme_clr4 text-white rounded-full px-5 py-2">
                                                        <button type='button'>{chl.title}</button>
                                                        <i
                                                            className="bi bi-x text-base leading-none cursor-pointer ms-4"
                                                            onClick={() => removeChannel(chl.channelId)}
                                                        ></i>
                                                    </div>
                                                ))
                                            }
                                        </div>
                                    </div>
                                </> : ''
                        }

                    </div>
                </section>
            </div>
        </div>
    )
}

export default YoutubeTarget